import React from 'react';
import Hero from './components/hero/Hero';
import Nav from './components/nav/Nav';
import Section from './components/section/Section';
import Footer from './components/footer/Footer';
import { landing } from './utils/landing';
import ScrollToTop from './components/utils/ScrollToTop';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
// import './App.css';

function App() {
  return (
    <Router>
      <ScrollToTop>
        <div className="App">
          {/* <Nav/> */}
          <div className="page-container">
          <Hero title={'TechOpps'} sub={'Take Initiative. Take Opportunity.'}/>
          {/* sub={'TechOpps is a non profit organization founded in the year 2020. It aims to deliver opportunites academically, professionally, and personally to passionate people in the tech industry.'}  */}
            {
              landing.map(section =>
                <Section className="page-section" title={section.title} body={section.body} type={section.type} img={section.image}/>
              )
            }
          </div>
          {/* <Footer menu={landing} /> */}
        </div>
      </ScrollToTop>
    </Router>
  );
}

export default App;
